import { render, staticRenderFns } from "./events-initiate.vue?vue&type=template&id=d6813f10"
import script from "./events-initiate.vue?vue&type=script&lang=js"
export * from "./events-initiate.vue?vue&type=script&lang=js"
import style0 from "./events-initiate.vue?vue&type=style&index=0&id=d6813f10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports